import CheckboxIndeterminateIcon from '@atlaskit/icon/core/checkbox-indeterminate';
import { token } from '@atlaskit/tokens';
import React, { type FunctionComponent } from 'react';

import { DatabaseEntryPickerOptionContainer } from '../entryPicker/databaseEntryPicker.styles';

export interface DatabaseEntryPickerOptionProps {
  label: string;
}

const DatabaseValuePickerOption: FunctionComponent<DatabaseEntryPickerOptionProps> = ({
  label,
}) => {
  return (
    <DatabaseEntryPickerOptionContainer>
      <CheckboxIndeterminateIcon label={''} color={token('color.icon.accent.teal')} />
      {label}
    </DatabaseEntryPickerOptionContainer>
  );
};

export default DatabaseValuePickerOption;
